import {
  Input,
  Output,
  Conversion,
  BlobSource,
  BufferTarget,
  WAVE,
  MP3,
  AdtsOutputFormat,
} from 'mediabunny'
import { UFile } from '@w/utils'

export interface ToAacOptions {
  bitrate?: number
}

export async function toAac(
  file: UFile,
  options?: ToAacOptions,
): Promise<UFile> {
  const type = file.type.toLowerCase()
  const ext = file.extension.toLowerCase()

  const isWav = type.includes('wav') || ext === 'wav'
  const isMp3 = type.includes('mp3') || type === 'audio/mpeg' || ext === 'mp3'

  if (!(isWav || isMp3)) return file

  const bitrate = options?.bitrate ?? (isWav ? 96000 : 128000)

  const input = new Input({
    source: new BlobSource(file.blob),
    formats: isWav ? [WAVE] : [MP3],
  })

  const target = new BufferTarget()
  const output = new Output({
    format: new AdtsOutputFormat(),
    target,
  })

  const conversion = await Conversion.init({
    input,
    output,
    audio: { codec: 'aac', bitrate },
  })

  await conversion.execute()

  if (!target.buffer) throw new Error('Conversion failed: no output buffer')

  const aacPath = file.path.replace(/\.(wav|mp3)$/i, '.aac')
  const blob = new Blob([target.buffer], { type: 'audio/aac' })
  return new UFile(blob, { path: aacPath, type: 'audio/aac' })
}
